import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/internal/operators/map';
import { APIEndPoints } from 'src/app/configs/api-endpoints';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotesBookmarksService {
  url = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  self() {
    return this.http.get<{ data: any, result: number, msg: string }>(`${this.url}users/self`).pipe(map((res) => {
       return res.data;
   }));
 }

 getNotesData(programActivationId:string,type:string){
  return this.http.get(`${this.url}${APIEndPoints.NotesAndBookmarks.GET_NOTES}?programActivationId=${programActivationId}&type=${type}`);
 }
}
